var map = {
	"./tutorial_apple.json": "2a57",
	"./tutorial_apricot.json": "f28d",
	"./tutorial_banana.json": "c688",
	"./tutorial_blueberry.json": "a8e0",
	"./tutorial_cherry.json": "0b91",
	"./tutorial_pepper.json": "905b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af36";